import { http as baseHttp } from '@aleph-alpha/lib-http';

// Use the Vite proxy route for IAM API calls
const baseURL = '/iam';

const iamHttp = baseHttp({
  baseURL,
});

export const addBearerTokenToIam = (type: string, token: string) => {
  iamHttp.updateConfig({
    headers: {
      Authorization: `${type} ${token}`,
    },
  });
};

export default iamHttp;
